import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { mcminnvilleConfig } from "./data";

export default function McMinnvillePage() {
  return <OregonCityPageTemplate config={mcminnvilleConfig} />;
}